export default __webpack_public_path__ + "static/media/default-monochrome-white.aa6b7d74.svg";